/**
 * Footer — Modern minimal footer.
 */

import React, { memo } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { APP_VERSION } from '../../version';

function getEnvironment() {
  if (typeof window === 'undefined') return 'Production';
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') return 'Development';
  if (host.includes('staging') || host.includes('stg')) return 'Staging';
  if (host.includes('test') || host.includes('uat')) return 'UAT';
  return 'Production';
}

const ENV = getEnvironment();

function Footer({ version = APP_VERSION }) {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      role="contentinfo"
      sx={{
        borderTop: '1px solid',
        borderColor: 'divider',
        py: 1.5,
        px: 3,
        mt: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 1,
      }}
    >
      <Typography sx={{ fontSize: '0.6875rem', color: 'text.disabled' }}>
        © {currentYear} ICT OPS
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        {ENV !== 'Production' && (
          <Typography
            sx={{
              fontSize: '0.625rem',
              fontWeight: 600,
              color: ENV === 'Development' ? '#059669' : '#d97706',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
            }}
          >
            {ENV}
          </Typography>
        )}
        <Typography sx={{ fontSize: '0.6875rem', color: 'text.disabled' }}>
          v{version}
        </Typography>
      </Box>
    </Box>
  );
}

export default memo(Footer);
